import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Product from '../components/Product/Product';
import { __ } from '../lib/i18n';
import { Footer } from '../components';
import {
  requestProducts,
  selectProduct,
  removeProductById,
} from '../redux/slices/products';
import TitleComponent from '../components/TitleComponent';
import noP from '../img/products.jpg';
import CategoriesTab from '../components/CategoriesTab';
import DnDProducts from '../components/ProductDnD/DnDProducts';
import ProductsSkeleton from '../components/ProductsSkeleton/ProductsSkeleton';
import links from "../img/links.svg";
import spinnerSrc from "../img/ajax-loader.gif"
import '../components/Product/Product.scss'
const Products = () => {
  const {
    app: { lang },
    products: { items, isFetchingProducts, errorProducts, showLoadMore },
    merchant: {
      item: { id },
    },
    merchantCategories: { category },
  } = useSelector((state) => state);
  const [nElem, setNElem] = useState(50);
  const [arrProduct, setArrProducts] = useState([]);
  const [fItems, setFItems] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    formatFItems();
  }, [items]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    formatProducts();
  }, [fItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatFItems = () => {
    const filtered = items.filter(it => it.category === category || category === "ALL");
    setFItems(filtered);
  }

  const handleEdit = (product) => {
    dispatch(selectProduct(product));
    history.push(`/products/${product.id}/edit`);
  };

  const handleDelete = (id) => {
    dispatch(removeProductById({ id: id }));
  };
  const handleExtractions = (product) => {
    dispatch(selectProduct(product));
    history.push(`/products/${product.id}/extractions`);
  };

  const formatProducts = () => {
    const extraStyle = {
      padding: 0,
    };
    let temp = fItems.map((p, k) => {
      return (
        <div className="col-12" style={extraStyle} key={k}>
          <Product
            lang={lang}
            product={p}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleExtractions={handleExtractions}
          />
        </div>
      );
    });
    setArrProducts(temp);
  };

  const getBackground = () => {
    if (isFetchingProducts) return null;
    if (fItems.length === 0) return 'productEmptyBackGround';
    return null;
  };

  const handleFetchNextPage = async () => {
    await dispatch(requestProducts());
  };

  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem(
        'scrollPosition',
        document.getElementById("pproducts").scrollTop.toString()
      );
    };

    const targetElement = document.getElementById("pproducts");

    targetElement.addEventListener('scroll', handleScroll);
    targetElement.addEventListener('touchmove', handleScroll);

    return () => {
      targetElement.removeEventListener('scroll', handleScroll);
      targetElement.removeEventListener('touchmove', handleScroll);
    };
  }, []);

  const displayProducts = () => {
    if (fItems.length === 0)
      return (
        <div /* className="px-10" */>
          <button
            className={`btn btn-warning small mb-0 ${!category && 'disabledElement'}`}
            style={{ color: '#FFF',minHeight: '40px' }}
            onClick={category ? () => history.push('/products/add'): null}>
            {' '}
            {__(lang, 'ADD_PRODUCT')}
          </button>
          <CategoriesTab />
          {isFetchingProducts && !errorProducts ? (
            <ProductsSkeleton />
          ) : (
            <div className="no-products">
              <p>{__(lang, 'NO_PRODUCTS')}</p>
              <img src={noP} />
            </div>
          )}
        </div>
      );

    return (
      <>
        <div>
          <div className="w-100 d-flex flex-row justify-between" style={{ alignItems: "center" }}>
            <button
              // className="btn btn-warning small mb-0 disabledElement"
            className={`btn btn-warning small mb-0 ${!category && 'disabledElement'}`}
            style={{ color: '#FFF', minHeight: '40px' }}
              // onClick={() => history.push('/products/add')}>
            onClick={category ? () => history.push('/products/add'): null}>
              {' '}
              {__(lang, 'ADD_PRODUCT')}
            </button>
            <button
              className="btn d-flex flex-row items-center m-0 buttonSimpleGreyHover"
              onClick={() => history.push('/products-links/')}
              style={{ color: "#266CF1", fontSize: "17px", borderRadius:'0.25rem' }}>
              Product Links <img className="pl-2" src={links} width={25} />
            </button>
          </div>
          <CategoriesTab />
          <div className="w-100">
            <div className="w-100 row" style={{ margin: 0 }}>
              <DnDProducts
                cards={fItems}
                productsList={arrProduct}
              />
            </div>
          </div>
          {showLoadMore && (
            <div className="d-flex justify-content-center mt-4">
              <button
                disabled={isFetchingProducts}
                className="btn btn-dark small mb-2"
                style={{ color: '#FFF' }}
                onClick={() => handleFetchNextPage()}>
                {isFetchingProducts ? <img src={spinnerSrc} style={{ width: "25px", height: "25px"}} />: 
                
                (__(lang, 'LOAD_MORE'))} 
              </button>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <main
      id="pproducts"
      role="main"
      className={
        'container-fluid  pt-3 ' + // 
        getBackground()
      }
      style={{ paddingLeft: '25px', paddingRight: '25px' }}>
      <TitleComponent title={__(lang, 'PRODUCT_LIST')} />
      {displayProducts()}
      <Footer />
    </main>
  );
};
export default Products;
